import { CloseIcon, IconButton, Text } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';

import type { TypeExchangeRegisterSecondStepValues } from '~/types/claim.types';

import styles from './ClaimExchangeDeliveryItemCell.module.scss';

type TypeData = TypeExchangeRegisterSecondStepValues['exchangeOrderItems'][number];

type TypeClaimExchangeDeliveryItemCellParams = {
  onClickDeleteButton: () => void;
};

export type TypeClaimExchangeDeliveryItemCellProps = TypeClaimExchangeDeliveryItemCellParams &
  CustomCellRendererProps<TypeData, TypeData['exchangeDeliveryItems'][number]['itemName']>;

/**
 * [교환 신청/조회] 교환 신청 등록 모달 > 교환 정보 입력 > 교환 상품 테이블 > 교환배송 상품명 셀
 */
const ClaimExchangeDeliveryItemCell = ({ value, onClickDeleteButton }: TypeClaimExchangeDeliveryItemCellProps) => {
  if (!value) return '-';

  return (
    <div className={styles['cell-wrapper']}>
      <Text size="large" ellipsis>
        {value}
      </Text>
      <IconButton icon={<CloseIcon size={20} color="gray400" />} onClick={onClickDeleteButton} />
    </div>
  );
};

export default ClaimExchangeDeliveryItemCell;
